var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "app-header w-full h-56 left-0 right-0 top-0 z-50 bg-white",
    class: [_vm.flat || _vm.border ? '' : 'shadow', {
      'fixed': _vm.fixed,
      'border-b-2': _vm.border
    }]
  }, [_c('container', {
    staticClass: "h-full",
    attrs: {
      "fluid": _vm.fluid,
      "xs-full": ""
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between h-full"
  }, [_c('div', {
    staticClass: "flex h-full mr-4 overflow-hidden"
  }, [!_vm.mobileMenu || _vm.showDesktopStyle ? _c('div', {
    staticClass: "flex items-center h-full",
    style: {
      width: _vm.logoWidthStyle ? _vm.logoWidthStyle : '100%'
    }
  }, [_c('nuxt-link', {
    staticClass: "flex items-center h-full pl-16 sm:pl-0",
    attrs: {
      "to": _vm.$web('index')
    }
  }, [!_vm.mobileLogo || _vm.showDesktopStyle ? _c('cdn-image', {
    attrs: {
      "src": _vm.logo,
      "size": {
        height: _vm.logoHeight,
        ratio: _vm.logoRatio
      },
      "alt": "SPOFERAN"
    }
  }) : _c('cdn-image', {
    attrs: {
      "src": _vm.mobileLogo,
      "alt": "SPOFERAN",
      "size": {
        height: 26,
        ratio: _vm.mobileLogoRatio
      }
    }
  })], 1)], 1) : _c('div', {
    staticClass: "h-full flex items-center justify-center pl-16 sm:pl-0"
  }, [_c('menu-btn', {
    model: {
      value: _vm.isActive,
      callback: function ($$v) {
        _vm.isActive = $$v;
      },
      expression: "isActive"
    }
  })], 1), _vm._v(" "), _vm._t("left_items", null, {
    "isDesktop": _vm.showDesktopStyle
  })], 2), _vm._v(" "), _vm._t("default", null, {
    "isDesktop": _vm.showDesktopStyle
  }), _vm._v(" "), _vm.showDesktopStyle ? _c('div', {
    staticClass: "h-full flex"
  }, [_vm._l(_vm.items, function (navItem, navItemKey) {
    return _c('btn', {
      key: navItemKey,
      staticClass: "h-full",
      class: {
        'pr-0': navItemKey === _vm.items.length - 1 && !_vm.$scopedSlots.items
      },
      attrs: {
        "aria-label": navItem.text ? navItem.text : navItem.alt,
        "to": navItem.to ? navItem.to : navItem.href,
        "exact": navItem.exact,
        "tile": "",
        "plain": "",
        "active-color": "primary"
      }
    }, [navItem.text ? _c('span', [_vm._v(_vm._s(navItem.text))]) : _vm._e(), _vm._v(" "), navItem.text_icon ? _c('icon', {
      attrs: {
        "icon": navItem.text_icon,
        "x-small": "",
        "force-size": ""
      }
    }) : _vm._e()], 1);
  }), _vm._v(" "), _vm._t("items", null, {
    "isDesktop": _vm.showDesktopStyle
  })], 2) : _c('div', {
    staticClass: "h-full flex pr-16 sm:pr-0"
  }, [_vm._l(_vm.mobileItems, function (navItem, navItemKey) {
    return _c('btn', {
      key: navItemKey,
      staticClass: "h-full",
      class: {
        'pr-0': navItemKey === _vm.mobileItems.length - 1 && !_vm.$slots.items
      },
      attrs: {
        "aria-label": navItem.text ? navItem.text : navItem.alt,
        "to": navItem.to ? navItem.to : navItem.href,
        "exact": navItem.exact,
        "tile": "",
        "plain": "",
        "active-color": "primary"
      }
    }, [navItem.text ? _c('span', [_vm._v(_vm._s(navItem.text))]) : _vm._e(), _vm._v(" "), navItem.text_icon ? _c('icon', {
      attrs: {
        "icon": navItem.text_icon,
        "x-small": "",
        "force-size": ""
      }
    }) : _vm._e()], 1);
  }), _vm._v(" "), _vm._t("items", null, {
    "isDesktop": _vm.showDesktopStyle
  })], 2)], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }